import React from 'react'
import profile from '../img/profile.png'
import { Link, withRouter } from 'react-router-dom'


const isActive = (history, path) => {
    if (history.location.pathname === path) {
        return { color: 'black' }
    } else {
        return { color: '#ffffff' } //ff9900
    }
}
const Navbar = ({ history }) => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
            <a className="navbar-brand js-scroll-trigger" href="http://sajidkhaki.com.s3-website.ap-south-1.amazonaws.com">
                <span className="d-block d-lg-none">Sajid Khaki</span>
                <span className="d-none d-lg-block">
                    <img className="img-fluid img-profile rounded-circle mx-auto mb-2 App-logo"
                        src={profile} alt="sajidkhaki" /></span>
            </a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span
                    className="navbar-toggler-icon"></span></button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/')} to='/'
                        >
                            About</Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/experience')} to='/experience'>Experience
                        </Link></li>
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger"
                            style={isActive(history, '/education')} to='/education'>Education
                        </Link></li>
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/skills')} to='/skills'>
                            Skills</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/interests')} to='/interests'>Interests
                        </Link></li>
                    <li className="nav-item"><Link className="nav-link js-scroll-trigger" style={isActive(history, '/awards')} to='/awards'>
                        Awards</Link></li>
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/certifications')} to='/certifications'>Certifications
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link js-scroll-trigger" style={isActive(history, '/projects')} to='/projects'>Projects
                        </Link></li>
                </ul>
            </div>
        </nav>
    )
}

export default withRouter(Navbar)